import { render } from "./TypeDistributionPie.vue?vue&type=template&id=483777ee&scoped=true"
import script from "./TypeDistributionPie.vue?vue&type=script&lang=js"
export * from "./TypeDistributionPie.vue?vue&type=script&lang=js"

import "./TypeDistributionPie.vue?vue&type=style&index=0&id=483777ee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483777ee"]])

export default __exports__